/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export const ResourceScope = {
  All: "all",
  Selected: "selected",
} as const;
export type ResourceScope = ClosedEnum<typeof ResourceScope>;

export const StartMode = {
  Now: "now",
  At: "at",
} as const;
export type StartMode = ClosedEnum<typeof StartMode>;

export type ActivatePrescriptionRequestBody = {
  definition?: string | undefined;
  expectedVersion?: number | undefined;
  expiresAt?: Date | undefined;
  externalNote: string;
  internalNote: string;
  operationId: string;
  organizationId: string;
  prescriptionId?: string | undefined;
  principalInput?: string | undefined;
  principalKind?: string | undefined;
  resourceKind?: string | undefined;
  resourceScope: ResourceScope;
  selectedResourceInputs?: Array<string> | undefined;
  startMode: StartMode;
  startsAt?: Date | undefined;
};

/** @internal */
export const ResourceScope$outboundSchema: z.ZodMiniEnum<typeof ResourceScope> =
  z.enum(ResourceScope);

/** @internal */
export const StartMode$outboundSchema: z.ZodMiniEnum<typeof StartMode> = z.enum(
  StartMode,
);

/** @internal */
export type ActivatePrescriptionRequestBody$Outbound = {
  definition?: string | undefined;
  expected_version?: number | undefined;
  expires_at?: string | undefined;
  external_note: string;
  internal_note: string;
  operation_id: string;
  organization_id: string;
  prescription_id?: string | undefined;
  principal_input?: string | undefined;
  principal_kind?: string | undefined;
  resource_kind?: string | undefined;
  resource_scope: string;
  selected_resource_inputs?: Array<string> | undefined;
  start_mode: string;
  starts_at?: string | undefined;
};

/** @internal */
export const ActivatePrescriptionRequestBody$outboundSchema: z.ZodMiniType<
  ActivatePrescriptionRequestBody$Outbound,
  ActivatePrescriptionRequestBody
> = z.pipe(
  z.object({
    definition: z.optional(z.string()),
    expectedVersion: z.optional(z.int()),
    expiresAt: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    externalNote: z.string(),
    internalNote: z.string(),
    operationId: z.string(),
    organizationId: z.string(),
    prescriptionId: z.optional(z.string()),
    principalInput: z.optional(z.string()),
    principalKind: z.optional(z.string()),
    resourceKind: z.optional(z.string()),
    resourceScope: ResourceScope$outboundSchema,
    selectedResourceInputs: z.optional(z.array(z.string())),
    startMode: StartMode$outboundSchema,
    startsAt: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
  }),
  z.transform((v) => {
    return remap$(v, {
      expectedVersion: "expected_version",
      expiresAt: "expires_at",
      externalNote: "external_note",
      internalNote: "internal_note",
      operationId: "operation_id",
      organizationId: "organization_id",
      prescriptionId: "prescription_id",
      principalInput: "principal_input",
      principalKind: "principal_kind",
      resourceKind: "resource_kind",
      resourceScope: "resource_scope",
      selectedResourceInputs: "selected_resource_inputs",
      startMode: "start_mode",
      startsAt: "starts_at",
    });
  }),
);

export function activatePrescriptionRequestBodyToJSON(
  activatePrescriptionRequestBody: ActivatePrescriptionRequestBody,
): string {
  return JSON.stringify(
    ActivatePrescriptionRequestBody$outboundSchema.parse(
      activatePrescriptionRequestBody,
    ),
  );
}
